import { render } from "./ShiftsTable.vue?vue&type=template&id=b5f44998"
import script from "./ShiftsTable.vue?vue&type=script&lang=js"
export * from "./ShiftsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__